
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import HomeIcon from '@mui/icons-material/HomeOutlined';


import { AccountCircleOutlined, AssignmentReturnOutlined, BookOutlined, Settings, CreditCard, BugReportOutlined, ClassOutlined, CurrencyLira,
    EventRepeat, LocalHospitalOutlined, NotificationsOutlined, PersonOutline, MonitorHeart, MonitorHeartOutlined, QuestionAnswerOutlined, SupervisedUserCircleOutlined,
    SupportAgent, TranslateOutlined, Notes, Monitor, HealthAndSafetyOutlined, BloodtypeOutlined, FactCheckOutlined, AssignmentIndOutlined, ReceiptLongOutlined, HowToRegOutlined,
    ShoppingBagOutlined, ShoppingCartOutlined, MedicalServicesOutlined,  HeadsetMicOutlined, MailOutlined, TrendingUpOutlined, AttachMoneyOutlined, NoteOutlined, CalendarTodayOutlined,
    PeopleOutlined, DescriptionOutlined, VisibilityOutlined, LanguageOutlined, CampaignOutlined } from '@mui/icons-material';

const icons = {
    HomeIcon: <HomeIcon />,
    FavoriteBorderOutlinedIcon: <FavoriteBorderOutlinedIcon />,
    ArrowForwardIosOutlinedIcon: <ArrowForwardIosOutlinedIcon />,
    CalendarMonthOutlinedIcon: <CalendarMonthOutlinedIcon />,
    ChatBubbleOutlineOutlinedIcon: <ChatBubbleOutlineOutlinedIcon />,
    ListOutlinedIcon: <ListOutlinedIcon />,
    MonitorHeartIcon: <MonitorHeartOutlined />,
    EvaluatedTreatments: <MonitorHeart />,
    BugReport: <BugReportOutlined />,
    CurrencyLira: <CurrencyLira />,
    QuestionAnswer: <QuestionAnswerOutlined />,
    SupervisedUserCircle: <SupervisedUserCircleOutlined />,
    Class: <ClassOutlined />,
    Translate: <TranslateOutlined />,
    AccountCircle: <AccountCircleOutlined />,
    Person: <PersonOutline />,
    LocalHospital: <LocalHospitalOutlined />,
    Notifications: <NotificationsOutlined />,
    Campaign: <CampaignOutlined />,
    Appointment: <BookOutlined />,
    Contact: <SupportAgent />,
    CreditCard: <CreditCard />,
    Settings: <Settings />,
    PastAppointment: <EventRepeat />,
    Notes: <Notes />,
    Monitor: <Monitor />,
    Emergency: <HealthAndSafetyOutlined />,
    Blood: <BloodtypeOutlined />,
    FactCheck: <FactCheckOutlined />,
    Assignment: <AssignmentIndOutlined />,
    ReceiptIcon: <ReceiptLongOutlined />,
    DoctorApproval: <HowToRegOutlined />,
    ShoppingBag: <ShoppingBagOutlined />,
    ShoppingCart: <ShoppingCartOutlined />,
    MedicalServices: <MedicalServicesOutlined />,
    HeadSet: <HeadsetMicOutlined />,
    Mail: <MailOutlined />,
    Chart: <TrendingUpOutlined />,
    Money: <AttachMoneyOutlined />,
    Note: <NoteOutlined />,
    Calendar: <CalendarTodayOutlined />,
    Assistant: <PeopleOutlined />,
    Description: <DescriptionOutlined />,
    Visibility: <VisibilityOutlined />,
    AssignmentReturn: <AssignmentReturnOutlined />,
    AppVersionConfiguration: <Settings />,
    Triage: <HealthAndSafetyOutlined />,
    Language: <LanguageOutlined />,
}

export default icons;